import { render, staticRenderFns } from "./registerStep1.vue?vue&type=template&id=560882f6&scoped=true&"
import script from "./registerStep1.vue?vue&type=script&lang=js&"
export * from "./registerStep1.vue?vue&type=script&lang=js&"
import style0 from "./registerStep1.vue?vue&type=style&index=0&id=560882f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560882f6",
  null
  
)

export default component.exports